import UserSvg from '@assets/images/svg/user.svg';
import React from 'react';
import { View } from 'react-native';

export function UserIcon({ size = 24, color = '#333333' }: { size?: number; color?: string }) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <UserSvg width={size} height={size} color={color} />
        </View>
    );
}


